import { render, staticRenderFns } from "./frmjelszovaltoztatas.vue?vue&type=template&id=5632d6eb&scoped=true&"
import script from "./frmjelszovaltoztatas.vue?vue&type=script&lang=js&"
export * from "./frmjelszovaltoztatas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632d6eb",
  null
  
)

export default component.exports